// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.WaybillNumber[data-v-7ae87eda] {\n  color: #00A551;\n  cursor: pointer;\n  padding: 0;\n}\n.omit[data-v-7ae87eda] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n}\n.verifier[data-v-7ae87eda] {\n  color: #00A551;\n  cursor: pointer;\n  padding: 0;\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
